<template>
  <div class="responsible-lending">
    <v-card color="white" width="100%" flat tile>
      <v-container class="py-10">
        <v-row>
          <!-- Responsible Lending -->
          <v-col cols="12">
            <h3 class="heading-h3">Responsible Lending</h3>
          </v-col>

          <v-col cols="12" lg="8">
            <p
              v-for="(listItem, index) in listItems1"
              :key="index + listItem.text"
              v-html="listItem.text"
              class="b-body-1"
            ></p>

            <h4 class="heading-h6"><strong>Credit Assessment</strong></h4>
            <p class="b-body-1">{{ listItems1Part2[0].text }}</p>
            <DefaultList :listItems="bulletItems1" />
            <p class="b-body-1">{{ listItems1Part2[1].text }}</p>

            <h4 class="heading-h6 mb-2">
              <strong>Electronic Loan Agreement and Authorisation</strong>
            </h4>
            <DefaultList :listItems="listItems2" />

            <h4 class="heading-h6 mb-2">
              <strong>Transparency and Consequences of Default</strong>
            </h4>
            <DefaultList :listItems="listItems3" />

            <h4 class="heading-h6 mb-2">
              <strong>Customer Responsibility</strong>
            </h4>
            <DefaultList :listItems="listItems4" />

            <h6 class="h6 mb-5">Regards,</h6>
            <p>
              <i>The Century Financial Services Team</i>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import DefaultList from "@/components/shared/lists/DefaultList";

export default {
  name: "LimeLoansResponsiblelending",
  components: { DefaultList },
  data() {
    return {
      listItems1: [
        {
          text: `At <strong>Century Financial Services (PTY) LTD</strong> (“Century FS”), we are committed to upholding the principles of responsible lending as outlined in the <strong>National Credit Act No. 34 of 2005 (NCA)</strong> and applicable South African legislation. Our approach to credit is built on fairness, transparency, and trust.`,
        },
      ],
      listItems1Part2: [
        {
          text: `We carefully assess each loan application to determine whether the applicant has a <strong>stable, verifiable income</strong> and sufficient affordability to meet their repayment obligations without compromising their basic living expenses. Our credit vetting process includes:`,
        },
        {
          text: `Loans are granted only where there is a reasonable belief that the customer can meet their financial obligations under the loan agreement.`,
        },
      ],
      bulletItems1: [
        { text: `A review of your declared income and expenditure` },
        { text: `Verification of your employment and income sources` },
        {
          text: `An affordability assessment and credit bureau checks in line with section 81(2) of the NCA`,
        },
      ],
      listItems2: [
        {
          text: `Before any funds are disbursed, the customer is required to electronically agree to the <strong>Loan Agreement</strong> and <strong>Debit Order Mandate</strong>. <br /><br />This is executed via an electronic signature, including the entry of a unique one-time PIN (OTP) sent to the customer’s registered mobile number.`,
        },
        {
          text: `This form of electronic consent is legally binding under South African law and carries the same enforceability as a handwritten signature.`,
        },
      ],
      listItems3: [
        {
          text: `<strong>Reporting to Credit Bureaus:</strong> Should your loan fall into arrears, we are legally obliged to report your account status to registered credit bureaus. This may affect your credit profile and your ability to access credit from Century FS and other financial institutions in the future.`,
        },
        {
          text: `<strong>Accrual of Interest:</strong> Interest continues to accrue on overdue amounts at the same rate agreed upon at the outset of the loan. We do not increase the interest rate due to default; however, interest will accrue daily on the outstanding balance until the debt is settled.`,
        },
        {
          text: `<strong>Default Charges:</strong> In line with the National Credit Regulations, a reasonable penalty fee may be levied on overdue amounts. These charges are stipulated in your Loan Agreement and comply with statutory limits.`,
        },
        {
          text: `<strong>Debt Recovery:</strong> If repayment obligations are not met, we will take reasonable steps to contact you and negotiate alternative repayment terms. Should you fail to engage or cooperate, Century FS may initiate recovery through internal or external <strong>debt collection agencies</strong> or <strong>legal proceedings</strong>, where associated legal and administrative costs will be borne by you.`,
        },
      ],
      listItems4: [
        {
          text: `Before taking out a loan, we urge you to consider your financial situation carefully. If you are uncertain about your ability to meet the repayment obligations, we advise against proceeding with the application.`,
        },
        {
          text: `Credit should only be used when it aligns with your affordability and long-term financial health.`,
        },
        {
          text: `If you anticipate difficulty in making repayment, we encourage you to contact us as early as possible at <a href="mailto:clientsupport@centuryfinancialservices.net">clientsupport@centuryfinancialservices.net</a>. Our customer care team is trained to assist you in renegotiating repayment terms, where applicable, to avoid escalation and preserve your credit standing.`,
        },
        {
          text: `Century Financial Services is committed to lending responsibly and helping you make informed credit decisions that support your financial goals.`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.responsible-lending {
  .h6 {
    font-family: "Raleway";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
}
</style>
